import * as React from 'react'
import './Loader.scss'

const Loader = () => {
	return (
		<div className={'Loader Loader'}>
			<div className={'Loader__gfxHolder'}>
				<div className={'Loader__gfx'} />
				<div className={'Loader__gfx'} />
				<div className={'Loader__gfx'} />
			</div>
		</div>
	)
}

export default Loader
